export var RecordActions;
(function (RecordActions) {
    RecordActions["ADD_SUBMITTED_FORM"] = "ADD_SUBMITTED_FORM";
    RecordActions["CLEAR_SUBMITTED_FORMS"] = "CLEAR_SUBMITTED_FORMS";
    RecordActions["ADD_GROUP_ID"] = "ADD_GROUP_ID";
    RecordActions["ADD_ORDER_ID"] = "ADD_ORDER_ID";
})(RecordActions || (RecordActions = {}));
